import { FC } from 'react'
import { FormProvider } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormGenerator, ModalWrapper } from '@microservices/wiskey-react-components'
import { Box } from '@mui/material'

import { AutocompleteOption } from '@types'
import { SearchFilterValue } from '@types'

import { useAddSimpleFilterDialog } from './hooks'
import { SimpleFilterValueInputs } from './SimpleFilterValueInputs'

export type SearchFilterForm = {
  id?: string
  code: string
  title: string
  objectTitle: string
  objectCode?: string
  object: AutocompleteOption | null
  isPinning: boolean
  value: SearchFilterValue
  visibility: boolean
}

type AddSimpleFilterDialogProps = {
  isEdit?: boolean
  open: boolean
  onClose: () => void
  onSave: (filter: SearchFilterForm) => void
  initialData?: Partial<SearchFilterForm>
  objectOptions: AutocompleteOption[]
}

export const AddSimpleFilterDialog: FC<AddSimpleFilterDialogProps> = ({
  isEdit,
  open,
  onClose,
  onSave,
  initialData,
  objectOptions,
}) => {
  const { t } = useTranslation()
  console.log('initialData', initialData)
  const { isDirty, handleSave, methods, searchFilterInputs } = useAddSimpleFilterDialog({
    initialData,
    objectOptions,
    onSave,
    onClose,
    open,
  })

  return (
    <ModalWrapper
      disabledSave={!isDirty}
      isShow={open}
      title={t(`searchFilterForm.formTitle.${isEdit ? 'edit' : 'new'}`)}
      containerStyle={{
        px: 0.5,
        py: 0.5,
      }}
      onClose={() => onClose()}
      onSave={handleSave}
    >
      <Box pb={2} pt={2} sx={{ maxHeight: 500, overflowY: 'auto', pr: 2 }}>
        <FormProvider {...methods}>
          <form>
            <FormGenerator inputs={searchFilterInputs} mainGridSpacing={0} />
            <SimpleFilterValueInputs />
          </form>
        </FormProvider>
      </Box>
    </ModalWrapper>
  )
}
